import { Icon, IconsName } from './icon';
import { cn } from '@/utils/commons';
import { TextColor } from '@/utils/types';

const enum Status {
  info = 'info',
  success = 'success',
  error = 'error',
}

const iconColors: { [key in Status]: TextColor } = {
  [Status.info]: 'text-muted-foreground',
  [Status.success]: 'text-success',
  [Status.error]: 'text-destructive',
};

const statusClasses: { [key in Status]: string } = {
  [Status.info]: 'text-muted-foreground',
  [Status.success]: 'text-success',
  [Status.error]: 'text-destructive',
};

const icons: { [key in Status]: IconsName } = {
  [Status.info]: 'InfoSquareRoundedFilled',
  [Status.success]: 'CircleCheckFilled',
  [Status.error]: 'AlertTriangleFilled',
};

function StatusLabel({ status, message, className }: { status: Status; message: string; className?: string }) {
  const statusClass = statusClasses[status];
  const iconColor = iconColors[status];
  const icon = icons[status];

  return (
    message && (
      <div
        className={cn(
          'pt-1 items-center gap-1.5 inline-flex',
          'text-sm font-normal leading-tight',
          statusClass,
          className
        )}
      >
        <Icon iconColor={iconColor} icon={icon} size={'xs'} />
        {message}
      </div>
    )
  );
}

export { Status, StatusLabel };
